<template>
  <div class="match-result">
    <span v-if="protest" class="match-result__disput">
      <div>Протест</div>
    </span>

    <span
      v-else
      class="match-result__count"
      :class="{
        'counter-empty': isEmptyScore
      }"
      v-text="`${score[0]} : ${score[1]}`"
    />
  </div>
</template>

<script>
export default {
  name: "MatchResult",
  props: {
    protest: Boolean,
    score: {
      type: Array,
      default: () => [0, 0]
    }
  },
  computed: {
    isEmptyScore() {
      return this.score[0] + this.score[1] === 0;
    }
  }
};
</script>

<style lang="scss">
.match-result {
  display: flex;
  align-items: center;
  justify-content: center;
  flex: 1 1 30% !important;

  padding: 0 10px;

  &__count {
    font-weight: bold;
    font-size: 52px;
    line-height: 1.4;
    color: #fff;

    &.counter-empty {
      color: rgba(#fff, 0.2);
    }
  }

  &__disput {
    background: #e72f31;
    color: white;
    border-radius: 3px;
    font-weight: bold;
    font-size: 24px;
    padding: 12px 44px;
  }

  @include breakpoint("sm-and-down") {
    &__disput {
      font-size: 18px;
      padding: 9px 34px;
    }
    &__count {
      font-size: 34px;
    }
  }

  @include breakpoint("xs-only") {
    margin-bottom: 20px;
  }
}
</style>
